import $ from "jquery";
import config from "flow/config";

let cachedCanvas: JQuery<HTMLElement> = undefined;

function getElement(elementId: string) {
    switch (elementId) {
        case config.elementIds.canvas:
            if (cachedCanvas) {
                return cachedCanvas;
            } else {
                return (cachedCanvas = $(elementId));
            }
        default:
            return $(elementId);
    }
}

function win() {
    return $(window);
}
function canvas() {
    return getElement(config.elementIds.canvas);
}
function bottonNavigation() {
    return getElement(config.elementIds.bottomNavigation);
}
function menu() {
    return getElement(config.elementIds.menu);
}
function workflow() {
    return getElement(config.elementIds.workflow);
}

export default {
    window: win,
    canvas: canvas,
    bottomNavigation: bottonNavigation,
    menu: menu,
    workflow: workflow
};
